function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "New_contact") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 4.74,
    y: 8.87,
    width: 22.14,
    height: 16.29,
    style: {
      fill: "#fff",
      stroke: "#808285",
      strokeMiterlimit: 10,
      strokeWidth: "0.623622059822083px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.57,14.28a2.06,2.06,0,0,0-2-2.15,2.06,2.06,0,0,0-2,2.15,2.06,2.06,0,0,0,2,2.16A2.07,2.07,0,0,0,11.57,14.28Z",
    style: {
      fill: "#e54918"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.65,19.89v1.78h5.91V19.89c0-1.66-2-2.5-3-2.5S6.65,18.23,6.65,19.89Z",
    style: {
      fill: "#e54918"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.33,
    y: 13.66,
    width: 7.81,
    height: 0.68,
    style: {
      fill: "#d5d5d5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.33,
    y: 16.42,
    width: 7.81,
    height: 0.68,
    style: {
      fill: "#d5d5d5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.33,
    y: 17.74,
    width: 7.81,
    height: 0.68,
    style: {
      fill: "#d5d5d5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.33,
    y: 19.09,
    width: 7.81,
    height: 0.68,
    style: {
      fill: "#d5d5d5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.25,
    y: 20.39,
    width: 7.81,
    height: 0.68,
    style: {
      fill: "#d5d5d5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "24.68 7.26 25.61 9.07 28.66 7.33 26.93 10.38 28.73 11.31 26.93 12.25 28.66 15.3 25.61 13.56 24.68 15.37 23.75 13.56 20.7 15.3 22.43 12.25 20.62 11.31 22.43 10.38 20.7 7.33 23.75 9.07 24.68 7.26",
    style: {
      fill: "#e9c181"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.87,
    y: 10.5,
    width: 1.62,
    height: 1.62,
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewContact);
export default __webpack_public_path__ + "static/media/new_contact.b195a481.svg";
export { ForwardRef as ReactComponent };